export default __webpack_public_path__ + "static/media/bnr2.9551be19.jpg";